import { EntityHeader, EntityName } from "@/shared/components/EntityPage";
import { type SessionRecord } from "@/shared/domain/sessions";

import styles from "./SessionDetail.module.css";
import { SessionHeader } from "./SessionHeader";
import { SessionTabBar } from "./SessionTabBar";

export interface SessionChromeProps {
  /** URL-derived session id. Used as the heading when ``session`` is ``null``. */
  sessionId: string;
  /**
   * Resolved session record, or ``null`` when the parent's ``useSession``
   * fetch is pending or failed. When ``null`` the heading falls back to
   * ``sessionId`` and the rest of the header is omitted; the tab strip
   * renders unconditionally because it reads its active value from the URL.
   */
  session: SessionRecord | null;
}

/**
 * Header and tab bar for ``/sessions/:sessionId``. Rendered on both the
 * success and error branches so the user sees the same heading hierarchy
 * whether or not the session record resolved.
 */
export function SessionChrome({ sessionId, session }: SessionChromeProps) {
  return (
    <div className={styles.headerSection}>
      {session ? (
        <SessionHeader session={session} />
      ) : (
        <EntityHeader
          type="session"
          name={<EntityName>{sessionId}</EntityName>}
        />
      )}
      <SessionTabBar />
    </div>
  );
}
